export default "__VITE_ASSET__AjyMzlgF__"